import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cortexXdr = defineConnector({
  identifier: "cortexXdr",
  name: "Cortex XDR",
  tagLine: "Extended detection and response",
  logo,
  protocol: "http",
  tags: ["featured", "security"],
  defaultUrlPattern: () =>
    "https://api-[^/]*\\.xdr\\.[^/]*\\.paloaltonetworks\\.com/.*",
  auth: customAuth("cortexXdr"),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log into your [Cortex XDR](https://www.paloaltonetworks.com/cortex/cortex-xdr) management console. Navigate to **Settings** > **Configurations** > **Integrations** > **API Keys** and generate a new API key, noting the security level (Standard or Advanced) you choose.",
        },
      ],
    },
    {
      title: "Enter your API details",
      items: [
        {
          kind: "input",
          label: "API key ID",
          required: true,
          target: { kind: "secrets", field: "apiKeyId" },
          helperText: "The numeric API key ID.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The API key value.",
        },
        {
          kind: "select",
          label: "Security level",
          required: true,
          defaultValue: "advanced",
          target: { kind: "configuration", field: "securityLevel" },
          helperText:
            "The security level chosen when the API key was generated.",
          options: [
            { value: "advanced", label: "Advanced" },
            { value: "standard", label: "Standard" },
          ],
        },
      ],
    },
    {
      title: "Enter your tenant details",
      items: [
        {
          kind: "input",
          label: "FQDN",
          placeholder: "api-your-tenant.xdr.us.paloaltonetworks.com",
          required: true,
          target: { kind: "configuration", field: "fqdn" },
          helperText:
            "Your Cortex XDR API FQDN. Found in Settings > Configurations > Integrations > API Keys.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ fqdn }) => ({
      url: `https://${fqdn}/public_api/v1/healthcheck`,
      method: "POST",
      body: JSON.stringify({}),
    }),
  },
});
